import React from 'react';
import { getNegativeFeedbackQuestions } from 'entries/utils';

const NegativeFeedbackResponses = ({ feedback, subcatSlug }) => {
  const allQuestions = getNegativeFeedbackQuestions(subcatSlug);
  const responses = allQuestions.filter(q => feedback && feedback[q.name]).map(q => q.label);

  if (responses.length == 0) {
    return null;
  }

  return (
    <div>
      <div className="sub-title">Didn't Like:</div>
      <ul>{ responses.map((res, i) => <li key={i}>- { res }</li>) }</ul>
    </div>
  );
}

export default NegativeFeedbackResponses;



// WEBPACK FOOTER //
// ./entries/components/negative_feedback_responses.jsx